import FileField from "./FileField";
import FileUploadField from "./FileUploadField";
import HiddenField from "./HiddenField";
import TextField from './TextField';

import * as NCRDataConstants from "../constants/NCRDataConstants";

import GetScreenFieldValue from "../functions/GetScreenFieldValue";

import EmployeeInfo from "../types/Employee/EmployeeInfo";
import Task from "../types/Task/Task";

type Props = {
    userData: EmployeeInfo,
    task: Task,
    files: File[],
    fileAddHandler?: (e: any) => void,
    fileRemoveHandler?: (e: any) => void
};

// Helper function to get screen field value
const getScreenFieldValue = (task: Task, dataName: string): string => {
    return GetScreenFieldValue(task.screen.screenFields, dataName);
};

export default function SupplyChainReview({ userData, task, files, fileAddHandler, fileRemoveHandler }: Props) {
    const getValue = (dataName: string): string => {
        return getScreenFieldValue(task, dataName);
    };

    const getMediaFiles = () => {
        const fileNamesFields = task.screen.screenFields.filter(x => x.dataName.includes(NCRDataConstants.ADDITIONAL_PHOTO_FILE_NAME));
        const fileFields = task.screen.screenFields.filter(x => x.dataName.includes(NCRDataConstants.ADDITIONAL_PHOTO_URL));

        return (
            fileNamesFields.map((field, i) => {
                return (
                    <div key={i}>
                        <TextField dataName={field.dataName} title={field.title} value={field.value} hintText={field.hintText} readonly={true} />
                        <FileField title={fileFields[i].title} value={fileFields[i].value} hintText={fileFields[i].hintText} />
                    </div>
                );
            })
        );
    };

    return (
        <div>
            <HiddenField dataName={NCRDataConstants.COMPLETE_BY} value={task.tier === 2 ? userData.email : getValue(NCRDataConstants.COMPLETE_BY)} />
            <FileUploadField dataName={NCRDataConstants.ADDITIONAL_PHOTO_URL} tableDataName={NCRDataConstants.ADDITIONAL_PHOTO_TABLE} filenameDataName={NCRDataConstants.ADDITIONAL_PHOTO_FILE_NAME} title={NCRDataConstants.PHOTO_TITLE} multiple={true} 
                fileadd={fileAddHandler} fileremove={fileRemoveHandler} filesIn={files} />
            {getMediaFiles()}
        </div>
    );
}
